module.exports = __webpack_public_path__ + "img/new-zealand.423537f7.svg";